import React from "react";
import "../styles/Policies.css";
import { Link } from "react-router-dom";

function Refund() {
  return (
    <div>
      <div className="Conditions-terms">
         <div className="breadcrumb">
          <Link to="/">Home</Link> /{" "}
          <Link to="/Refund-Policy">Refund-Policy</Link>
        </div> 
        <h1 className="Condition">Refund-Policy</h1>
        <div className="content">
          <p>
            At Sankalp Ayurveda, your health and happiness mean everything to us.
            We know choosing the right supplement is a big decision. We
            genuinely believe in the power of our supplements, and we want you
            to experience their benefits with complete confidence. and we are
            committed to ensuring your experience is as smooth and worry-free as
            possible. Your trust matters more than a transaction. If something
            isn’t right, rest assured that we’re here to make it right.
          </p>
        </div>

        <h3 className="section-title">For Products Shipped by Us</h3>
        <p className="text">
          We want you to feel confident when shopping with us. If you need to
          return a product, we’re happy to help within 7 days of receiving your
          order, under the following circumstances:
        </p>

        <h3 className="section-title">For Orders Not Yet Shipped</h3>
        <p className="text">
          We understand that plans can change. If you wish to cancel your order,
          you can do so within 24 hours of purchase by emailing us at
          Sankalphealth10@gmail.com
        </p>
        <ul className="policy-list">
          <ul>
            <li>
              If the order hasn’t been packaged or shipped, we’ll cancel it and
              refund your full amount.
            </li>
            <li>
              {" "}
              Email us at Sankalphealth10@gmail.com, and we’ll send you a replacement
              right away.{" "}
            </li>
          </ul>
        </ul>
        <h3 className="section-title">We Care About Your Wellness</h3>
        <p className="text">
          At Sankalp Ayurveda, your wellness is our purpose. Your health and
          happiness mean the world to us, and we’ll do everything we can to
          ensure your experience with us is nothing short of exceptional.
        </p>
        <ul className="policy-list">
          <ul>
            <li>Email: Sankalphealth10@gmail.com</li>
            <li>Phone: +91 9211710043</li>
          </ul>
        </ul>
      </div>
    </div>
  );
}

export default Refund;
